module.exports = __webpack_public_path__ + "img/Ld.c83d98e1.png";